import config from '../../config';

// TODO check if we need or we can delete this
export const isFirstMirror = () => {
    return window.location.host === config.FIRST_MIRROR_DOMAIN_NAME || '';
};
